import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import FloatingSocialButtons from "../components/FloatingSocialButtons";
import TrainingRatesSection from "../components/TrainingRates";

export default function TrainingRates(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <TrainingRatesSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
